(function() {
    angular
        .module("alertsModule")
        .config(alertsRouter)

    alertsRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function alertsRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){
        $stateProvider
        .state("alerts", {
            url: "/alerts",
            templateUrl: "app/components/alerts/alerts.view.html",
            controller : "AlertsController"
        })
        .state("alert-details-message-board", {
            url: "/alert-details/id/:alert_id/message-board/:component_id",
            templateUrl: "app/components/alerts/alert-details-message-board.view.html",
            controller : "AlertDetailsMessageBoardController"
        })
        .state("alert-details-tracker", {
            url: "/alert-details/id/:alert_id/tracker/:component_id",
            templateUrl: "app/components/alerts/alert-details-tracker.view.html",
            controller : "AlertDetailsTrackerController"
        })

        $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
